<template lang="html">
  <v-container grid-list-md align-center justify-center pt-0 pl-0 pr-0 pb-0>
    <ComponentOverviewMap @activeMenu="activeMenu"/>
  </v-container>
</template>

<script>
import ComponentOverviewMap from '@/components/ComponentOverviewMap';
export default {
  components: {
    ComponentOverviewMap,
  },
  data(){
    return {
      active: ''
    }
  },
  methods:{
    gotoLink(link){
      this.$router.push(link)
    },
    activeMenu(status){
      this.$emit('activeMenu', status)
    }
  }
}
</script>
